const e=async(e,t)=>{let{data:n}=await e.get(`/orgs`,{params:t});return n};export{e as getOrgs};
//# sourceMappingURL=get-orgs.mjs.map